<template>
  <div class="content-item " v-if="ContentInfo">
    <div class="content-image">
      <img :src="LocalUrl" alt="">
      <el-image :src="'http://'+ContentInfo.photoInfoVO.address" class="img"></el-image>
    </div>
    <div class="content-title" >
      <router-link :to="'/content/name='+ContentInfo.name"><a>{{ ContentInfo.name }}</a></router-link>
    </div>
    <div class="content-detail">
      <pre>{{ContentInfo.photoInfoVO.description }}</pre>
    </div>
    <div class="learn-more">
<!--      <span>查看更多 <i class="el-icon-arrow-right"  ></i></span>-->
      <router-link :to="'/content/name='+ContentInfo.name"><a>查看更多 <i class="el-icon-arrow-right"  ></i></a></router-link>
<!--      <ripeav-more url-link="/news" ripeav-more="查看更多" style="margin:  0 auto;text-align: center;"></ripeav-more>-->

    </div>
  </div>
</template>

<script>
export default {
  name: "HomeContentItem",
  props:{
    ContentInfo:{
      default(){
        return []
      }
    },
    LocalUrl:{},
  },
  mounted() {

    window.addEventListener('mousewheel',this.GetChangeUI,false )
  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
  .content-item {
    width: 20vw;
    padding: 0 10px;
    display: flex;
    min-height: 500px;
    flex-direction: column;
    align-items: center;
    animation: TOUP 2s ease;
    &:hover{
      .learn-more{
        display: block;
      }
    }
    .content-image{
      text-align: center;
      img{
        width: 200px;
        height: auto;
      }
      .img{
        display: none;
      }
      &:hover{
        transform: translateY(-10px);
        transition: all 2s;
        img{
          display: none;
        }
        i{
          display: block;
        }
        .img{
          display: block;
          border-radius: 4px;
        }
      }
    }
    .content-title{

      width: 100%;
      text-align: center;
      margin-top: 25px;
      a{
        text-decoration: none;
        height: 32px;
        font-size: 32px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 48px;
      }
    }
    .content-detail{
      margin: 8px 0;
      min-height: 54px;

      pre{
        width: 22vw;
        white-space: pre-wrap;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 38px;
        min-height: 120px;
        text-align: center;
      }
    }
    .learn-more{
      display: none;
      line-height: 24px;
      span{
        cursor: pointer;
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #188ACB;
        line-height: 24px;
        i{
          font-size: 14px;
        }

      }
    }
  }
  @-webkit-keyframes TOUP {
    from{
      opacity: 0.1;
    }
    to{
      opacity: 1;

    }
  }
</style>